import Spinner from 'components/Spinner'

export default function FullPageLoginSpinner({ text, children }) {
    return <div className="d-flex flex-column align-items-center justify-content-center" style={{height: '100vh', width: '100vw', position: 'fixed', left: 0}}>
        <Spinner icon="door-open"/>
        {text && <p style={{marginTop:'3rem', textAlign: 'center'}}>
            {text}
        </p>}
        {children}
    </div>
}
